import { calculateIntakeName } from "../../../../helpers";
import { REQUIRED_DOCS } from "../../../academic/constants";
import {
  IProgramApplicationViewBackEndModel,
  IProgramApplicationViewFrontEndModel,
} from "../../types";
import { EducationType } from "../../../school/constants/types";

export function parseToProgramApplicationViewFrontEndModel(
  backendData: IProgramApplicationViewBackEndModel,
  educationType: EducationType,
): IProgramApplicationViewFrontEndModel {
  const parsedExtraDocs =
    backendData.extraDocs.map((extraDoc) => ({
      ...extraDoc.file,
      isRemovable: false,
    })) || [];

  const parsedReqDocs = backendData.program.academic.requiredDocs.map(
    (reqDoc) => {
      const filledReqDoc = backendData.requiredDocs.find(
        (filledReqDoc) => filledReqDoc.requiredDocId === reqDoc.id,
      );
      const existedDoc = REQUIRED_DOCS.find((d) => d.name === reqDoc.name);

      return {
        received: {
          ...reqDoc,
          name: existedDoc
            ? existedDoc.longName
            : reqDoc.name.charAt(0).toUpperCase() + reqDoc.name.slice(1),
        },
        filled: filledReqDoc,
      };
    },
  );

  const parsedAppForm = backendData.program.academic.applicationForms.map(
    (appForm) => {
      const filledAppForm = backendData.filledForms.find(
        (filledAppForm) => filledAppForm.applicationFormId === appForm.id,
      );

      return {
        received: appForm,
        filled: filledAppForm,
      };
    },
  );

  const selectedIntake =
    backendData.program.intakes?.filter(
      (item) => item.startDate === backendData.intake.startDate,
    ) || [];

  const intakes =
    backendData.program.intakes?.map((intake) => ({
      ...intake,
      name: `${intake.startDate} ${calculateIntakeName(intake.startDate)}`,
    })) || [];

  const selectedIntakes = {
    name: `${selectedIntake[0]?.startDate} ${calculateIntakeName(
      selectedIntake[0]?.startDate,
    )}`,
    id: selectedIntake[0]?.id,
    deadline: selectedIntake[0]?.deadline,
    startDate: selectedIntake[0]?.startDate,
  };

  return {
    injectedData: {
      educationType,
      student: backendData.student,
      branch: {
        name: backendData.branch.name,
        id: backendData.branch.id,
      },
      program: {
        academic: {
          applicationForms: backendData.program.academic.applicationForms,
          applicationLink: backendData.program.academic.applicationLink,
          requiredDocs: backendData.program.academic.requiredDocs,
        },
        intakes: intakes,
      },
      filledForms: parsedAppForm,
      requiredDocs: parsedReqDocs,
      extraDocs: parsedExtraDocs,
      comment: backendData.comment,
    },
    step1: {
      isLinkConfirmed: backendData.isLinkConfirmed,
      intake: selectedIntakes,
    },
    selectedIntake: selectedIntakes,
  };
}
